// extracted by mini-css-extract-plugin
module.exports =  {"seller-response-time":"hfEcrcj","sellerResponseTime":"hfEcrcj","separation-ellipse":"ySEEY40","separationEllipse":"ySEEY40"};